import Vue from 'vue'
import {globalStore} from '../../main.js'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import VModal from 'vue-js-modal'
import Countries from 'i18n-iso-countries'
import CountriesEN from 'i18n-iso-countries/langs/en.json'
import CountriesDE from 'i18n-iso-countries/langs/de.json'
Countries.registerLocale(CountriesEN);
Countries.registerLocale(CountriesDE);
import UserMethods from '../../shared/userMethods.js'

Vue.use(VModal, { dialog: true });

export default {
    name: 'editUser',
    components: {
        PulseLoader
    },
    data() {
        return {
            data:null,
            userId: null,
            user: {
                FirstName: null,
                LastName: null,
                Email: null,
                PrincipalName: null,
                Domain: null,
                SAMAccountName: null,
                Language: null,
                OU: null,
                DisplayName: null,
                Phone: null,
                Website: null,
                CountryCode: null,
                State: null,
                Location: null,
                Street: null,
                PostalCode: null,
                PersonalTitle: null,
                Department: null,
                Company: null,
                Description: null,
                Info: null,
                Groups: [],
                IsActive: null,
                ThumbnailPhoto: null,
                ProxyAddresses: []
            },
            errors: {},
            summaryErrors: [],
            userClone: null,
            userLoadingError: false,
            userLoaded: false,
            showSpinner: false,
            editMode: false,
            isNew: false,
            isNewDigiUser: false,
            countryCodes: [],
            country: null,
            allGroups: [],
            selectedGroup: null,
            selectedProxyAddressPrefix: null,
            proxyAddressValue: null,
            proxyAddressesPrefix: [],
            photoFileInput: null,
            hasDigiGroups: false,
            languages: globalStore.culture.languages,
            showEmailSpinner: false
        }
    },
    methods: {
        onPhotoInputChange: function(e){
            if(e.target.files.length){
                var file = e.target.files[0];
                if(file.type != 'image/jpeg'){
                    globalStore.showInfo(null, this.labels.ONLY_JPG, 'danger');
                    return;
                }
                if(file.size > 102400){
                    globalStore.showInfo(null, this.labels.FILE_SIZE, 'danger');
                    return;
                }
                this.tryLoadPhoto(e.target.files[0]);
            }     
        },
        browseImage: function(){
            this.$refs.fileInput.click();
        },
        removeImage: function(){
            this.user.ThumbnailPhoto = null;
        },
        tryLoadPhoto: function (file) {
            var self = this;
            var reader = new FileReader();
            reader.onload = function () {
                var imageObject = new Image();
                imageObject.onload = () => {
                    if(imageObject.width > 96 || imageObject.heigth > 96){
                    globalStore.showInfo(null, self.labels.DIMENSIONS, 'danger');
                    return;
                    }
                self.user.ThumbnailPhoto = reader.result;
                }
                imageObject.src = reader.result;
            };
            reader.readAsDataURL(file);

            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
            },
        isValid: function(propertyName){
            if(this.errors[propertyName] && this.errors[propertyName].length > 0){
                return false;
            }
            return true;
        },
        propertyError: function(propertyName){
            if(this.errors[propertyName] && this.errors[propertyName].length > 0){
                return this.errors[propertyName][0];
            }
            return null;
        },
        saveUser: function(){
            var self = this;

            var thumbnailPhoto = this.user.ThumbnailPhoto ? this.user.ThumbnailPhoto.replace('data:image/jpeg;base64,','') : null;

            var model = {
                AccountName: this.user.SAMAccountName,
                FirstName : this.user.FirstName,
                LastName : this.user.LastName,
                PreferredLanguage: this.user.Language,
                Phone: this.user.Phone,
                HomePage: this.user.Website,
                Country: this.user.CountryCode,
                Province: this.user.State,
                City: this.user.Location,
                StreetAddress: this.user.Street,
                Zip: this.user.PostalCode,
                PersonalTitle: this.user.PersonalTitle,
                Department: this.user.Department,
                Company: this.user.Company,
                Description: this.user.Description,
                Info: this.user.Info,
                Groups: this.user.Groups,
                Photo: thumbnailPhoto,
                ProxyAddresses: this.user.ProxyAddresses,
                DisplayName: this.user.DisplayName,
                Email: this.user.Email,
                UserType: this.user.UserType
            }

            const apiUrl = self.isNew ? globalStore.host + "CreateADUser" : globalStore.host + "EditUserSave";

            this.showSpinner = true;
            self.$axios.post(apiUrl, model, { headers: { Authorization: "Bearer " + self.$session.get("jwt"), "Language": self.cultureCode } })
            .then(response => {
                self.showSpinner = false;
                if(response.status === 200){
                    if(response.data.Result == 'Errors'){
                        this.errors = {};
                        this.errors.FirstName = response.data.Errors.FirstName;
                        this.errors.LastName = response.data.Errors.LastName;
                        this.errors.Language = response.data.Errors.PreferredLanguage;
                        this.errors.Email = response.data.Errors.Email;
                        this.errors.Phone = response.data.Errors.Phone;
                        this.errors.Website = response.data.Errors.HomePage;
                        this.errors.CountryCode = response.data.Errors.Country;
                        this.errors.State = response.data.Errors.Province;
                        this.errors.Location = response.data.Errors.City;
                        this.errors.Street = response.data.Errors.StreetAddress;
                        this.errors.PostalCode = response.data.Errors.Zip;
                        this.errors.PersonalTitle = response.data.Errors.PersonalTitle;
                        this.errors.Department = response.data.Errors.Department;
                        this.errors.Company = response.data.Errors.Company;
                        this.errors.Description = response.data.Errors.Description;
                        this.errors.Groups = response.data.Errors.Groups;
                        this.errors.ProxyAddresses = response.data.Errors.ProxyAddresses;
                        this.errors.DisplayName = response.data.Errors.DisplayName;
                        this.errors.CostCenter = response.data.Errors.CostCenter;
                        this.errors.JobTitle = response.data.Errors.JobTitle;
                        this.errors.FirstNameUnicode = response.data.Errors.FirstNameUnicode;
                        this.errors.LastNameUnicode = response.data.Errors.LastNameUnicode;
                        this.errors.Gender = response.data.Errors.Gender;
                        this.summaryErrors = response.data.SummaryErrors;

                    } else if(response.data.Result == 'Ok'){
                        this.errors = {};
                        this.editMode = false;
                        
                        globalStore.showInfo(null, self.labels.USER_WAS_SAVED, 'success', 5000);
                        setTimeout(function() {
                            if (self.isNew) {
                                self.$router.push('/dashboard/userslist/' + response.data.user.AccountName);
                                self.userId = response.data.user.AccountName;
                            }
                            self.loadUser();
                        }, 1000);
                    }
                }
            })
            .catch(err => {
                self.showSpinner = false;
                var	errHandled = false;
                if (err.response) {
                    if (err.response.status === 401) {
                        errHandled = true;
                        self.$session.destroy();
                        self.$router.push("/login");
                    } else if (err.response.status === 400) {
                        var errMsg = self.labels[err.response.data.Message];
                        if (!errMsg) {
                            errMsg = err.response.data.Message;
                        }
                        globalStore.showInfo(null, errMsg, 'danger', 4000);
                        errHandled = true;
                    } else if (err.response.status == 404) {
                        globalStore.showInfo(null, self.labels.USER_NOT_FOUND, 'danger');
                        errHandled = true;
                    }
                }
                if (!errHandled) {
                    globalStore.showInfo(null, self.labels.UNKNOWN_ERROR, 'danger');
                }
                return err;
            });
        },
        cancelEditMode: function(){
            this.user = JSON.parse(JSON.stringify(this.userClone));
            this.errors = {};
            this.summaryErrors = [];
            if(this.photoFileInput){
                this.photoFileInput.value = '';
                this.photoFileInput.type = '';
                this.photoFileInput.type = 'file';
            }

            this.editMode = false;
            if (this.isNew) {
                this.$router.push('/dashboard/userslist')
            }
        },
        removeGroup: function(group, index){
            Vue.delete( this.user.Groups, index );
        },
        setPassword: function(){
			this.$router.push('/dashboard/setPassword/' + this.userId);
		},
        addGroup: function(){
            if(this.selectedGroup){
                if (!this.user.Groups) {
                    this.user.Groups = new Array();
                }
                this.user.Groups.push(this.selectedGroup);
                this.selectedGroup = null;
            }
        },
        isGroupEditable: function(group){
            return this.allGroups.indexOf(group) > -1;
        },
        addProxyAddress: function() {
            if(this.selectedProxyAddressPrefix && this.selectedProxyAddressPrefix.length > 0
            && this.proxyAddressValue && this.proxyAddressValue.length > 0){
                this.user.ProxyAddresses.push(this.selectedProxyAddressPrefix + ':' + this.proxyAddressValue);
                this.proxyAddressValue = null;
            }
        },
        removeProxyAddress: function(proxyAddress, index){
            Vue.delete( this.user.ProxyAddresses, index );
        },
        isProxyAddressEditable: function(proxyAddress){
            if(proxyAddress){
                var splitted = proxyAddress.split(':');
                if(splitted.length>0 && this.proxyAddressesPrefix.indexOf(splitted[0]) > -1){
                    return true;
                }
            }
            return false;
        },
        toEditMode: function(){
            this.userClone = JSON.parse(JSON.stringify(this.user)); 
            this.editMode = true;
        },
        getUserDetails: function(){
            var self = this;
            //TODO: change new user definition
            this.isNewDigiUser = self.userId=="new",
            this.isNew = this.isNewDigiUser;

            const apiUrl = globalStore.host + "UserDetails?userName=" + self.userId;

            var promise = new Promise(function(resolve, reject) {
                self.$axios
                .get(apiUrl, { headers: { Authorization: "Bearer " + self.$session.get("jwt") } })
                .then(response => {
                    if (response.status === 200) {
                        resolve(response.data);
                        if (self.user != null) {
                            self.hasDigiGroups = response.data.HasDigiGroups;
                        }

                        if (self.isNew) {
                            self.toEditMode();
                        }
                    } else{
                        reject('');
                    }
                })
                .catch(err => {
                    console.log(err);
                    if (err.response) {
                        if (err.response.status === 401) {
                            self.$session.destroy();
                            self.$router.push("/login");
                        } else if (err.response.status === 404) {
                            globalStore.showInfo(null, self.labels().USER_NOT_FOUND, 'danger');
                        }
                    }
                    reject('');
                    return err;
                });
            })

            return promise;
        },
        getSettingsFromServer: function(){
            var self = this;
            const apiUrl = globalStore.host + "EditUserSettings";

            var promise = new Promise(function(resolve, reject) {
                self.$axios
                .post(apiUrl, {}, { headers: { Authorization: "Bearer " + self.$session.get("jwt") } })
                .then(response => {
                    if (response.status === 200) {               
                        resolve(response.data);
                    } else{
                        reject('');
                    } 
                })
                .catch(err => {
                    console.log(err);
                    if (err.response && err.response.status === 401) {
                        self.$session.destroy();
                        self.$router.push("/login");
                    }
                    reject('');
                    return err;
                });
            })

            return promise;
        },
        unlockUser: function(){
			UserMethods.unlockUser(this, this.user.SAMAccountName, () => {
				this.user.Locked = false;
			}); 	
		},
        activateUser: function(event){
            UserMethods.activateUser(this, this.user.SAMAccountName, () => {
                this.user.IsActive = true;
            })
        },
        deactivateUser: function(event){
            UserMethods.deactivateUser(this, this.user.SAMAccountName, () => {
                this.user.IsActive = false;
            })
        },
        sendWelcomeEmail: function(appType, noPasswd){
            UserMethods.sendWelcomeEmail(this, this.user.SAMAccountName, this.user.Language, appType, noPasswd);
        },
        getWelcomeEmailPreview: function(appType, noPasswd) {
            var self = this;
            self.showEmailSpinner = true;
            var html = UserMethods.getWelcomeEmailPreview(this, this.user.SAMAccountName, appType, noPasswd)
                .then(response => {			
                    self.showEmailSpinner = false;
                    self.$modal.show('dialog', {
                        text: response.data,
                        buttons: []
                    })
                })
                .catch(err => {
                    self.showEmailSpinner = false;
                    console.log(err);
                    globalStore.showInfo(null, this.labels().ERROR_EMAIL_GENERATE, 'danger');
                });	
        },
        sendForgotPasswordEmail: function(appType){
            UserMethods.sendForgotPasswordEmail(this, this.user.SAMAccountName, this.user.Language, appType);
        },
        getForgotPasswordEmailPreview: function(appType) {
            var self = this;
            self.showEmailSpinner = true;
            var html = UserMethods.getForgotPasswordEmailPreview(this, this.user.SAMAccountName, appType)
                .then(response => {			
                    self.showEmailSpinner = false;
                    self.$modal.show('dialog', {
                        text: response.data,
                        buttons: []
                    })
                })
                .catch(err => {
                    self.showEmailSpinner = false;
                    console.log(err);
                    globalStore.showInfo(null, this.labels().ERROR_EMAIL_GENERATE, 'danger');
                });	
        },
        createUser: function(data){
            this.user.FirstName = data.FirstName;
            this.user.LastName = data.LastName;
            this.user.Email = data.Email;
            this.user.PrincipalName = data.PrincipalName;
            this.user.Domain = data.Domain;
            this.user.SAMAccountName = data.AccountName;
            this.user.Language = data.PreferredLanguage;
            this.user.OU = data.OrganizationUnit;
            this.user.DisplayName = data.DisplayName;
            this.user.Phone = data.Phone;
            this.user.Website = data.HomePage;
            this.user.CountryCode = data.Country;
            this.user.State = data.Province;
            this.user.Location = data.City;
            this.user.Street = data.StreetAddress;
            this.user.PostalCode = data.Zip;
            this.user.PersonalTitle = data.PersonalTitle;
            this.user.Company = data.Company;
            this.user.Description = data.Description;
            this.user.Info = data.Info;
            this.user.Groups = data.Groups;
            this.user.IsActive = data.Enabled;
            this.user.Locked = data.Locked;
            this.user.UserType = data.UserType,
            this.user.ThumbnailPhoto = data.Photo ? 'data:image/jpeg;base64,' + data.Photo : null;
            this.user.ProxyAddresses = data.ProxyAddresses ? data.ProxyAddresses : [];
            this.user.HasDigiGroups = data.HasDigiGroups;
            this.user.ExtensionAttribute6 = data.ExtensionAttribute6;
            this.user.CanonicalName = data.CanonicalName;
            this.user.Department = data.Department;

            this.hasDigiGroups = data.HasDigiGroups;
        },
        loadUser: function() {
            globalStore.openedSubPoint = this.$parent.usersListText;
            globalStore.openedPoint = this.$parent.actionText;
            
            this.userId = this.$route.params.id;

            Promise.all([
                this.getUserDetails(),
                this.getSettingsFromServer()
            ])
            .then(
                results  => {
                    var userDetails = results[0];
                    var settings = results[1];
                
                    this.countryCodes = settings.Countries.map((countryCode) => {
                        return {
                            Text: Countries.getName(countryCode, this.cultureCode),
                            Value: countryCode
                        }
                    }).sort(function(a, b){
                        if (a.Text < b.Text)
                        return -1;
                        if (a.Text > b.Text)
                        return 1;
                        return 0;
                    });

                    this.allGroups = settings.EditableRoles;
                    this.proxyAddressesPrefix = settings.ProxyAddressesValidPrefix ? settings.ProxyAddressesValidPrefix : [];

                    this.createUser(userDetails);
                    this.userLoaded = true;

                },
                error => {
                    this.userLoadingError = true;
                }
            )
            .then(() => {
                this.showSpinner = false;
            })
        },
        getCountryCode: function (code) {
            return globalStore.culture.getCountryCode(code);
        }
    },
    
    computed: {
        photoSrc: function(){
            return this.user.ThumbnailPhoto ? this.user.ThumbnailPhoto : 'static/img/no-avatar.jpg';
        },
        openedSubPoint: function() {
            return this.labels.USERS_LIST_TEXT;
        },
        openedPoint: function() {
            return this.labels.ACTION_TEXT;
        },
        cultureCode: function(){
            return globalStore.culture.locale;
        },
        availableGroups: function(){
            var self = this;
            return self.allGroups
            .filter(function(item){
                var result = true;
                if (self.user.Groups != null) {
                    for (var i = 0; i < self.user.Groups.length; i++) {
                        if(self.user.Groups[i] === item){
                            result = false;
                        }
                    }
                }
                return result;
            });
        },
        labels: function() {
            return globalStore.culture.strings.EditUser;
        },
        isCurrentUserAdmin: function() {
          return globalStore.isCurrentUserAdmin;
        },
    },
    watch: {
        user: {
            handler: function(to, from){
                this.country = Countries.getName(to.CountryCode, this.cultureCode);
                if (this.isNew) {
                    if (to.FirstName != null && to.LastName != null) {
                        this.user.DisplayName = to.LastName + ' ' + to.FirstName;
                    }
                    if (to.Email != null ) {
                        this.user.PrincipalName = to.Email
                    }
                }
            },
            deep: true
        },
        cultureCode (to, from){
            this.countryCodes = this.countryCodes.map(function(item) {
                item.Text = Countries.getName(item.Value, to)
                return item;
                }).sort(function(a, b){
                if (a.Text < b.Text)
                    return -1;
                if (a.Text > b.Text)
                    return 1;
                return 0;
                });
            }
        },
        beforeCreate: function () {
        if (!this.$session.exists()) {
            this.$router.push("login");
            return;
            }
        },
        created: function() {    
            this.loadUser();
        }
}



// WEBPACK FOOTER //
// ./src/components/EditUser/EditUser.js